import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "latest-news"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DKShelfSlider = _resolveComponent("DKShelfSlider")!
  const _component_DKContainer = _resolveComponent("DKContainer")!

  return (_ctx.fragment && _ctx.newsItems.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_DKContainer, null, {
          default: _withCtx(() => [
            _createVNode(_component_DKShelfSlider, {
              title: _ctx.fragment?.title,
              items: _ctx.newsItems,
              locale: _ctx.locale,
              tag: "h2"
            }, null, 8, ["title", "items", "locale"])
          ]),
          _: 1
        })
      ], 512))
    : _createCommentVNode("", true)
}